import React from 'react'
import { Star } from 'iconsax-react'
import { useAppDispatch } from '@SonarCX/hooks/redux'

import CommonButton from '../CommonButton'

import { patchFavorites } from '@SonarCX/slices/favorites'
import { useAreYouSure } from '@SonarCX/providers/AreYouSureProvider'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import useTaskMultiEdit from '../hooks/useTaskMultiEdit'

const Unfavorite: React.FC = () => {
  const dispatch = useAppDispatch()

  const { setV2, setTitle, setReason, setSubtext, setAction } = useAreYouSure()
  const { user } = useEnvironment()
  const { selected, numTasks, suffix } = useTaskMultiEdit()

  const acceptAction = React.useCallback(() => {
    const toRemove: APIFavorite[] = selected.map(id => ({
      item_id: id,
      type: 'task',
      deleted: true
    }))
    dispatch(patchFavorites(user?.id, toRemove))
  }, [selected, dispatch, user])

  const handleClick = React.useCallback(() => {
    setV2(true)
    setTitle(`Unfavorite task${suffix}`)
    setReason(`Are you sure you want to unfavorite ${numTasks} task${suffix}?`)
    setSubtext('')
    setAction(acceptAction)
  }, [
    suffix,
    numTasks,
    setV2,
    setTitle,
    setReason,
    setSubtext,
    setAction,
    acceptAction
  ])

  return (
    <CommonButton
      title='Unfavorite'
      Icon={props => <Star {...props} variant='Linear' />}
      onClick={handleClick}
    >
      <div>Unfavorite</div>
    </CommonButton>
  )
}

export default Unfavorite
